<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-tabs v-model="activeName" @tab-click="handleClick">
       
        <el-tab-pane label="微信" name="2">

          <!-- 查询条件 -->
          <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
            <el-row :gutter="35">
              <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
                <el-form-item label="小程序名称">
                  <el-input v-model="queryParams.name" @change="search" @clear="search" placeholder="小程序名称"
                    clearable></el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
                <el-form-item label="主体">
                  <el-input v-model="queryParams.owner" @change="search" @clear="search" placeholder="主体"
                    clearable></el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
                <el-form-item label="状态">
                  <el-select v-model="queryParams.status" @change="search" @clear="search" placeholder="请选择状态" clearable
                    class="w100">
                    <el-option label="正常" :value=1></el-option>
                    <el-option label="隐藏" :value=0></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
                <div class="btn_left">
                  <el-button size="medium" type="primary" :loading="loading" @click="search">查询</el-button>
                  <el-button size="medium" @click="reset">重置</el-button>
                </div>
              </el-col>
            </el-row>

          </el-form>
          <!--工具栏 -->
          <div class="div_buttom">
            <el-button size="medium" @click="getList">刷新列表</el-button>
            <el-button size="medium" type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
          </div>
          <!-- 列表 -->
          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" size="medium"
            :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }" :cell-style="{ textAlign: 'center' }"
            @selection-change="handleSelectionChange" border v-loading="loading">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column label="ID">
              <template slot-scope="scope">{{ scope.row.id }}</template>
            </el-table-column>
            <el-table-column prop="name" label="小程序名称" width="100">
              <template slot-scope="scope">{{ scope.row.name }}</template>
            </el-table-column>
            <el-table-column prop="name" label="appid" width="150">
              <template slot-scope="scope">{{ scope.row.uuid }}</template>
            </el-table-column>
            <el-table-column prop="name" label="管理员名称">
              <template slot-scope="scope">{{ scope.row.user_name }}</template>
            </el-table-column>
            <el-table-column prop="name" label="IOS支付商户名">
              <template slot-scope="scope">{{ scope.row.cert_ios_name }}</template>
            </el-table-column>
            <el-table-column prop="name" label="IOS支付商户号">
              <template slot-scope="scope">{{ scope.row.ios_merchant_id }}</template>
            </el-table-column>
            <el-table-column prop="name" label="Android支付商户名">
              <template slot-scope="scope">{{ scope.row.cert_android_name }}</template>
            </el-table-column>
            <el-table-column prop="name" label="Android支付商户号">
              <template slot-scope="scope">{{ scope.row.android_merchant_id }}</template>
            </el-table-column>

            <el-table-column prop="name" label="回流时间">
              <template slot-scope="scope">{{ scope.row.backflow_cycle }}天</template>
            </el-table-column>
            <el-table-column prop="name" label="主体">
              <template slot-scope="scope">{{ scope.row.owner }}</template>
            </el-table-column>
            <el-table-column prop="name" label="状态">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
                <el-tag type="danger" v-else>隐藏</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="默认渠道号" width="200">
              <template slot-scope="scope">{{ scope.row.zrll_code }}</template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="medium" @click="WxPaymentConfig(scope.row)">支付配置</el-button>
                <el-button type="text" size="medium" @click="handleUpdate(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
            :limit.sync="queryParams.pageSize" @pagination="getList" />

        </el-tab-pane>


        <!--  抖音小程序配置 -->
        <el-drawer :close-on-click-modal="false" :wrapperClosable="true" :title="title"
          :visible.sync="dialogFormVisible" :before-close="handleClose" size="50%" direction="rtl">

          <div class="demo-drawer__content">

            <el-form ref="ruleForm" :model="form" :rules="rules" size="medium">

              <el-row :gutter="35">

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="平台类型" :label-width="formLabelWidth" prop="platform_type">
                    <el-select v-model="form.platform_type" placeholder="请选择平台类型" :disabled="!!this.form.id"
                      style="width: 100%;">
                      <!-- <el-option label="抖音" :value=1></el-option> -->
                      <el-option label="微信" :value=2></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="小程序名称" :label-width="formLabelWidth" prop="name">
                    <el-input v-model="form.name" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="appid" :label-width="formLabelWidth" prop="uuid">
                    <el-input v-model="form.uuid" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="secret" :label-width="formLabelWidth" prop="secret">
                    <el-input v-model="form.secret" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="支付token" :label-width="formLabelWidth" prop="pay_token">
                    <el-input v-model="form.pay_token" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="支付SALT" :label-width="formLabelWidth" prop="pay_salt">
                    <el-input v-model="form.pay_salt"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="应用私钥" :label-width="formLabelWidth" prop="private_key">
                    <el-input v-model="form.private_key" type="textarea" autosize autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="应用公钥" :label-width="formLabelWidth" prop="public_key">
                    <el-input v-model="form.public_key" type="textarea" autosize autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="平台公钥" :label-width="formLabelWidth" prop="platform_public_key">
                    <el-input v-model="form.platform_public_key" type="textarea" autosize autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="抖音ios支付客服号" :label-width="formLabelWidth">
                    <el-input v-model="form.atomic_pay_im_id"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="抖音ios支付客服名" :label-width="formLabelWidth">
                    <el-input v-model="form.atomic_pay_im_name"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="抖音广告位ID" :label-width="formLabelWidth">
                    <el-input v-model="form.ad_placement_id"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="抖音广告完播赠币" :label-width="formLabelWidth">
                    <el-input v-model="form.ad_placement_balance"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="回流时间" :label-width="formLabelWidth" prop="backflow_cycle">
                    <el-input v-model="form.backflow_cycle"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="主体" :label-width="formLabelWidth" prop="owner">
                    <el-input v-model="form.owner"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="描述" :label-width="formLabelWidth" prop="description">
                    <el-input v-model="form.description"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="状态" :label-width="formLabelWidth" prop="status">
                    <el-radio-group v-model="form.status">
                      <el-radio :label=1>正常</el-radio>
                      <el-radio :label=0>隐藏</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>

                <el-col v-if="form.iaa_switch == 1" :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="IAA自动播放广告" prop="iaa_autoad" :label-width="formLabelWidth">
                    <el-radio-group v-model="form.iaa_autoad">
                      <el-radio :label="1">开启</el-radio>
                      <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>

                <el-col v-if="form.iaa_autoad == 1" :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="广告自动播放倒计时" :label-width="formLabelWidth" prop="autoad_sec">
                    <el-input v-model.number="form.autoad_sec" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

          </div>
          <div class="demo-drawer__footer">
            <el-button @click="dialogFormVisibleDy">取 消</el-button>
            <el-button type="primary" @click="submitForm" :loading="loading">确 定</el-button>
          </div>
        </el-drawer>

        <!--  微信小程序配置  -->
        <el-drawer :close-on-click-modal="false" :title="title" :wrapperClosable="true"
          :visible.sync="wechatFormVisible" :before-close="handleClose" size="50%" direction="rtl">
          <div class="demo-drawer__content">
            <el-form ref="ruleForm" :model="wxform" :rules="rules" size="medium">

              <el-row :gutter="35">
                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="平台类型" :label-width="formLabelWidth" prop="platform_type">
                    <el-select v-model="wxform.platform_type" placeholder="请选择平台类型" :disabled="!!this.wxform.id"
                      style="width: 100%;">
                      <!-- <el-option label="抖音" :value=1></el-option> -->
                      <el-option label="微信" :value=2></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="小程序名称" :label-width="formLabelWidth" prop="name">
                    <el-input v-model="wxform.name" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="appid" :label-width="formLabelWidth" prop="uuid">
                    <el-input v-model="wxform.uuid" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="secret" :label-width="formLabelWidth" prop="secret">
                    <el-input v-model="wxform.secret" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="原始ID" :label-width="formLabelWidth" prop="secret">
                    <el-input v-model="wxform.original_id" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="回流时间" :label-width="formLabelWidth" prop="backflow_cycle">
                    <el-input v-model="wxform.backflow_cycle" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="主体" :label-width="formLabelWidth">
                    <el-input v-model="wxform.owner" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="管理员名称" :label-width="formLabelWidth">
                    <el-input v-model="wxform.user_name" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="管理员手机号" :label-width="formLabelWidth">
                    <el-input v-model="wxform.mobile" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="描述" :label-width="formLabelWidth" prop="description">
                    <el-input v-model="wxform.description" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="状态" :label-width="formLabelWidth" prop="status">
                    <el-radio-group v-model="wxform.status">
                      <el-radio :label=1>正常</el-radio>
                      <el-radio :label=0>隐藏</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>

                <el-col v-if="wxform.iaa_switch == 1" :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="IAA自动播放广告" prop="iaa_autoad" :label-width="formLabelWidth">
                    <el-radio-group v-model="wxform.iaa_autoad">
                      <el-radio :label="1">开启</el-radio>
                      <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>

                <el-col v-if="wxform.iaa_autoad == 1" :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="自动播放倒计时" :label-width="formLabelWidth" prop="autoad_sec">
                    <el-input v-model.number="wxform.autoad_sec" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

              </el-row>

            </el-form>
          </div>
          <div class="demo-drawer__footer">
            <el-button @click="wechatFormVisibleW">取 消</el-button>
            <el-button type="primary" @click="submitForm" :loading="loading">确 定</el-button>
          </div>
        </el-drawer>

        <!--  微信支付配置  -->
        <el-drawer :close-on-click-modal="false" :title="title" :wrapperClosable="true"
          :visible.sync="wechatPaymentFormVisible" :before-close="handleClose" size="50%" direction="rtl">
          <div class="demo-drawer__content">
            <el-form ref="ruleForm" :model="wxpaymentform" :rules="rules" size="medium">
              <el-row :gutter="35">

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="IOS支付证书" :label-width="formLabelWidth" prop="cert_id">
                    <el-select v-model="wxpaymentform.cert_id" placeholder="请选择IOS支付证书" style="width: 100%;">
                      <el-option v-for="dict in Certs" :key="dict.dictValue" :label="dict.name" :value="dict.id" />
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="Android支付证书" :label-width="formLabelWidth" prop="android_cert_id">
                    <el-select v-model="wxpaymentform.android_cert_id" placeholder="请选择Android支付证书"
                      style="width: 100%;">
                      <el-option v-for="dict in Certs" :key="dict.dictValue" :label="dict.name" :value="dict.id" />
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="OfferID(支付应用ID)" :label-width="formLabelWidth">
                    <el-input v-model="wxpaymentform.offer_id" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="现网AppKey" :label-width="formLabelWidth">
                    <el-input v-model="wxpaymentform.app_key" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="Token(令牌)" :label-width="formLabelWidth">
                    <el-input v-model="wxpaymentform.push_token" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="22" :xl="22" class="mb20">
                  <el-form-item label="EncodingAESKey(消息加密密钥)" :label-width="formLabelWidth">
                    <el-input v-model="wxpaymentform.push_encoding_aes_key" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>

          <div class="demo-drawer__footer">
            <el-button @click="wechatPaymentFormVisibleW">取 消</el-button>
            <el-button type="primary" @click="submitCertForm" :loading="loading">确 定</el-button>
          </div>
        </el-drawer>

      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { appListAPI } from '@/api/appletlist/applist/index';
import { processErrors } from "@/utils/errorHandler";

export default {
  components: {},
  data() {
    return {
      // 表单标题
      title: "",
      // 抖音表单
      form: {
        atomic_pay_im_id: "",
        atomic_pay_im_name: "",
        ad_placement_id: "",
        ad_placement_balance: "",
        status: 1,
        iaa_switch: 0,
        iaa_autoad: 0,
        autoad_sec: 3,
      },
      //微信表单
      wxform: {
        status: 1,
        iaa_switch: 0,
        iaa_autoad: 0,
        autoad_sec: 3,
      },
      // 表单宽度
      formLabelWidth: "140px",
      // 抖音添加修改弹窗
      dialogFormVisible: false,
      // 微信添加修改弹窗
      wechatFormVisible: false,
      // 微信支付配置弹窗
      wechatPaymentFormVisible: false,
      //微信支付配置
      wxpaymentform: {},
      Certs: [],
      // tab栏切换
      activeName: '2',
      // 控制搜索显示
      SearchFlag: false,
      // 查询条件
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        status: "",
        owner: "",
        name: "",
      },
      // 总条数
      total: 0,
      // 列表数据
      tableData: [],
      multipleSelection: [],
      // 校验规则
      rules: {
        name: [
          { required: true, message: "请输入小程序名称", trigger: "blur" }
        ],
        uuid: [
          { required: true, message: "请输入appid", trigger: "blur" }
        ],
        secret: [
          { required: true, message: "请输入secret", trigger: "blur" }
        ],
        pay_token: [
          { required: true, message: "请输入支付token", trigger: "blur" }
        ],
        pay_salt: [
          { required: true, message: "请输入支付SALT", trigger: "blur" }
        ],
        private_key: [
          { required: true, message: "请输入应用私钥", trigger: "blur" }
        ],
        public_key: [
          { required: true, message: "请输入应用公钥", trigger: "blur" }
        ],
        platform_public_key: [
          { required: true, message: "请输入平台公钥", trigger: "blur" }
        ],
        backflow_cycle: [
          { required: true, message: "请输入回流时间", trigger: "blur" }
        ],
        platform_type: [
          { required: true, message: "请选择平台类型", trigger: "blur" }
        ],
        cert_id: [
          { required: true, message: "请选择IOS支付证书", trigger: "blur" }
        ],
        android_cert_id: [
          { required: true, message: "请选择Android支付证书", trigger: "blur" }
        ],
        autoad_sec: [
          {
            type: 'number',
            min: 3,
            message: "自动播放时间最小为3秒",
            trigger: "blur"
          }
        ]

      },
      loading: false,
    };
  },
  created() {
    this.getList()
  },
  methods: {
    dialogFormVisibleDy() {
      this.$refs['ruleForm'].resetFields();
      this.dialogFormVisible = false
    },
    wechatFormVisibleW() {
      this.$refs['ruleForm'].resetFields();
      this.wechatFormVisible = false
    },
    wechatPaymentFormVisibleW() {
      this.$refs['ruleForm'].resetFields();
      this.wechatPaymentFormVisible = false
    },
    // 关闭弹窗
    handleClose(done) {
      done();
      this.$refs['ruleForm'].resetFields();
    },
    // 点击tab切换
    handleClick(tab, event) {
      // eslint-disable-next-line no-console
      // this.reset();
      this.getList();
    },
    // 获取列表
    getList() {
      this.loading = true;
      this.tableData = [];
      this.total = 0;
      let api = appListAPI()
      this.queryParams.platform_type = this.activeName

      api.getAppList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false;
      })
    },
    // 点击查询
    search() {
      this.queryParams.pageNo = 1;
      this.getList();
    },
    // 重置表单
    resetFrom() {
      this.form = {
        id: null,
        name: "",
        uuid: "",
        secret: "",
        pay_token: "",
        pay_salt: "",
        private_key: "",
        public_key: "",
        platform_public_key: "",
        atomic_pay_im_id: "",
        atomic_pay_im_name: "",
        ad_placement_balance: "",
        ad_placement_id: "",
        backflow_cycle: "",
        owner: "",
        description: "",
        status: 1,
        iaa_switch: 0,
        iaa_autoad: 0,
        autoad_sec: 3,
      }
    },
    // 重置按钮
    reset() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        status: "",
        owner: "",
        name: "",
      }
      this.getList();
    },

    // 搜索开关
    addSearch() {
      this.SearchFlag = !this.SearchFlag
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.resetFrom();
      if (this.activeName == 1) {
        this.form = {
          // extends: {
          //   iaa_switch: 0,
          //   iaa_autoad: 0,
          //   autoad_sec: 0
          // }
        }
        this.dialogFormVisible = true;
      } else if (this.activeName == 2) {
        this.wxform = {
          // extends: {
          //   iaa_switch: 0,
          //   iaa_autoad: 0,
          //   autoad_sec: 0
          // }
        }
        this.wechatFormVisible = true;
      }
      this.title = "添加应用";
    },

    /** 修改按钮操作 */
    handleUpdate(row) {
      this.resetFrom();
      const id = row.id || this.ids
      appListAPI().getAppInfo(id).then(response => {
        if (this.activeName == 1) {
          this.form = response.data;
          this.dialogFormVisible = true;
        } else if (this.activeName == 2) {
          this.wxform = response.data;
          this.wechatFormVisible = true;
        }

        this.title = "修改应用";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          if (this.activeName == 1) {
            delete this.form.platform_type_text;
            if (this.form.id != null) {
              appListAPI().addOrUpdateApp(this.form).then(response => {
                if (response.code == 0) {
                  this.$message({
                    message: "添加成功",
                    type: 'success'
                  });
                  this.dialogFormVisible = false;
                  this.getList();
                } else {
                  processErrors(response);
                }
              });
            } else {
              appListAPI().addOrUpdateApp(this.form).then(response => {
                if (response.code == 0) {
                  this.$message({
                    message: "修改成功",
                    type: 'success'
                  });
                  this.dialogFormVisible = false;
                  this.getList();
                } else {
                  processErrors(response);
                }
              });
            }
          } else if (this.activeName == 2) {
            delete this.wxform.platform_type_text;
            if (this.wxform.id != null) {
              appListAPI().addOrUpdateApp(this.wxform).then(response => {
                if (response.code == 0) {
                  this.$message({
                    message: "修改成功",
                    type: 'success'
                  });
                  this.wechatFormVisible = false;
                  this.getList();
                } else {
                  processErrors(response);
                }
              });
            } else {
              appListAPI().addOrUpdateApp(this.wxform).then(response => {
                if (response.code == 0) {
                  this.$message({
                    message: "添加成功",
                    type: 'success'
                  });
                  this.wechatFormVisible = false;
                  this.getList();
                } else {
                  processErrors(response);
                }
              });
            }
          }

        }
      });
    },

    /**
     * 微信支付配置提交
     */
    submitCertForm() {
      appListAPI().editMappsCerts(this.wxpaymentform).then(response => {
        this.$message({
          message: "修改成功",
          type: 'success'
        });
        this.wechatPaymentFormVisible = false;
        this.getList();
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    WxPaymentConfig(row) {
      const id = row.id || this.ids;
      this.SelectCerts();
      this.wechatPaymentFormVisible = true;
      this.title = "支付配置";
      appListAPI().getAppInfo(id).then(response => {
        this.wxpaymentform = response.data;
      });
    },

    SelectCerts() {
      let api = appListAPI();
      api.CertsList().then((res) => {
        if (res.code == 0) {
          this.Certs = res.data;
        } else {
          processErrors(res);
        }
      });
    },
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.demo-drawer__content {
  height: calc(100% - 80px);
  /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto;
  /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.demo-drawer__footer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  /* 将宽度设置为100%,占满整个容器 */
  margin-bottom: 20px;
  /* 增加底部边距 */
}

.demo-drawer__footer .el-button {
  //flex: 1; /* 让按钮平分容器宽度 */
  width: 320px;
  /* 设置按钮宽度为120px */
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}
</style>